module.exports = __webpack_public_path__ + "static/media/instantEFT.fa023636.svg";